module.exports = __webpack_public_path__ + "static/bag-electronics-phone-f9f6ee92b1f5e692fd8159ca05b4e36f.jpg";